// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export class Utils {
    private static timeout: any;

    static debounce(func: Function, wait: number, immediate: boolean) {
        const context = this, args = arguments;
        const later = () => {
            Utils.timeout = null;
            if (!immediate) func.apply(this, args);
        };
        const callNow = immediate && !Utils.timeout;
        clearTimeout(Utils.timeout);
        Utils.timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };

    static abortDebounce() {
        clearTimeout(Utils.timeout);
        Utils.timeout = null;
    }
};



// WEBPACK FOOTER //
// ./assets/scripts/modules/utils.ts